<template>
  <div>
    <v-card flat>
      <v-breadcrumbs class="systock-breadcrump" dark>
        <v-breadcrumbs-item>Gerenciamento de Grupos e Filiais</v-breadcrumbs-item>
      </v-breadcrumbs>
      <v-tabs centered>
        <v-tab>
          <v-icon left>mdi-ray-start-end</v-icon>
          Sistemas de Integração
        </v-tab>
        <v-tab>
          <v-icon left>mdi-apps</v-icon>
          Sistemas e Aplicativos
        </v-tab>

        <v-tab-item class="ma-0">
          <cfg-sistemas-integração class="mx-1"></cfg-sistemas-integração>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <cfg-sistemas-aplicativos class="mx-1"></cfg-sistemas-aplicativos>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>

import CfgSistemasAplicativos from "./../cfg/CfgSistemasAplicativos.vue"
import CfgSistemasIntegração from "./../cfg/CfgSistemasIntegração.vue"

export default {
  components: {
    CfgSistemasAplicativos,
    CfgSistemasIntegração,

  },
  name: "Cfg",

  data() {
    return {
      comprador: 0,
      grupo: 0,
    };
  },

  created() {
    this.Helpers.verificarToken();
  },
};
</script>
<style>
.altura-tabela .v-data-table__wrapper {
  height: calc(100vh - 300px) !important;
}
</style>
